module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "mask weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.maskHeight + 'px', 75)
    }),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onCancled($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-box weex-ct weex-div",
    style: ({
      top: _vm._px2rem(_vm.boxMarginTop + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "box-title-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "box-title-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-input-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    staticClass: "box-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-evt-input": ""
    },
    domProps: {
      "value": _vm.inputName
    },
    nativeOn: {
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-btn-group weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "box-btn-wrapper btn-border-r weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onCancled($event)
      }
    }
  }, [_c('p', {
    staticClass: "box-btn-text cancel-text weex-el weex-text",
    style: ({
      color: _vm.cancelColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "box-btn-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onOkClicked($event)
      }
    }
  }, [_c('p', {
    staticClass: "box-btn-text weex-el weex-text",
    style: ({
      color: _vm.confirmColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v("确定")])])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50169bcf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50169bcf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-promt/index.vue
// module id = 609
// module chunks = 0 1